<script>
import ComputeCard from './computeCard.vue'

export default {
  name: 'LeftBar',
  components: { ComputeCard },
  data() {
    return {
      deadLine: false, // 不滑动2s后展开
    }
  },
  computed: {
    showCompute() {
      return this.$store.state.user.setShowCompute
    },
    showTel() {
      return this.$store.state.user.setShowTel || this.deadLine
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    this.timer = setTimeout(() => {
      this.deadLine = true
    }, 2000)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const distance = window.pageYOffset || document.documentElement.scrollTop
      this.$store.commit('user/setShowTel', distance > 0)
    },
    open() {
      this.$refs.telRef.classList.remove('active')
      this.$store.commit('user/setShowCompute', true)
    },
    close() {
      this.$refs.telRef.classList.add('active')
    },
    onMouseEnter() {
      this.deadLine = true // 其实只要hover 或者到时间展开 后面就不需要闭合了
    },
    // onMouseLeave() {
    //   if (this.showCompute || this.deadLine) return
    //   if (this.timer) clearTimeout(this.timer)
    //   if (this.showTel) return
    //   this.$refs.telRef.classList.remove('active')
    // },
  },
}
</script>

<template>
  <div class="left-bar" @mouseenter="onMouseEnter">
    <div class="ele-con">
      <img class="ele" :src="require('@/assets/images/left-ele.gif')" alt="" />
    </div>
    <div ref="telRef" class="tel-con" :class="[showTel ? 'active' : '']">
      <div ref="textRef" class="text">销售热线&nbsp;&nbsp; 0571-85785223</div>
      <div class="compute" @click="open">价格计算器</div>
    </div>
    <ComputeCard v-if="showCompute" @close="close" />
  </div>
</template>

<style scoped lang="less">
.left-bar {
  user-select: none;
  position: fixed;
  z-index: 2000;
  left: 20px;
  bottom: 22px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #007aff;

  .ele-con {
    width: 100%;
    height: 100%;
    border-radius: inherit;
    background: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    .ele {
      width: 100%;
      height: 100%;
      transform: scale(1.5);
    }
  }
  .tel-con {
    width: 0;
    overflow: hidden;
    padding-right: 22px;
    height: 48px;
    background: rgba(0, 0, 0, 0.85);
    border-radius: 42px;
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    transition: width 0.6s ease;
    .compute {
      font-size: 13px;
      width: 100px;
      height: 28px;
      background-color: #cc0000;
      color: #ffffff;
      border-radius: 6px;
      margin-left: 16px;
      line-height: 28px;
      text-align: center;
      cursor: pointer;
    }
    .tel {
      width: 22px;
      margin-right: 10px;
    }
    .text {
      display: none;
      color: #ffffff;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
    }
  }

  .tel-con.active {
    text-wrap: nowrap;
    width: 379px;
    .text {
      display: block;
    }
  }
}
</style>
